import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class AssignVehicleToJobRequestStore {
  total = 0;
  loading = false;

  getVehiclesUsingCompanyId = [];
  getDriversUsingCompanyId = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      getVehiclesUsingCompanyId: observable,
      getDriversUsingCompanyId: observable,

      getAssetData: action,
      getDriverData: action,
      addData: action,
    });
    this.rootStore = rootStore;
  }

  async addData(data) {
    // console.log("data", data);
    // var postData = data;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=jobRequest&a=JobRequestAssignVehicle",
    //     "postData=" + base64Input
    //   );
    // console.log(response);

    const response = await postApi
      .getClient("NodeCoreUrl")
      .post("jobRequestList/JobRequestAssignVehicle", data);
    return response;
  }

  async getAssetData({ companyId }) {
    // console.log(companyId, "id");
    const postData = { companyId: companyId };
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("jobRequestList/getCompanyVehicles", { params: postData });
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=jobRequest&a=getCompanyVehicles",
    //     "postData=" + base64Input
    //   );
    // console.log(response);

    this.getVehiclesUsingCompanyId = response?.data?.data;
    return response?.data?.data;
  }
  async getDriverData({ companyId }) {
    // console.log(companyId, "id");
    const postData = { companyId };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=jobRequest&a=getCompanyDrivers",
    //     "postData=" + base64Input
    //   );
    // console.log(response);

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("jobRequestList/getCompanyDrivers", { params: postData });

    this.getDriversUsingCompanyId = response?.data?.data;
    return response?.data?.data;
  }
}

export default AssignVehicleToJobRequestStore;
